<template>
  <v-dialog
    v-model="dialog"
    max-width="620"
    persistent
    style="background:#fff;"
  >
    <template v-slot:activator="{ on }">
      <!--v-btn  v-on="on">
        Inställningar <v-icon small>mdi-cog</v-icon>
      </v-btn-->
      <v-list-item v-on="on">
        <v-list-item-icon>
          <v-icon>mdi-cog</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Inställningar</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-dialog v-model="duplicateDialog" max-width="480">
      <v-card>
        <v-card-title
          >Är du säker på att du vill duplicera
          {{ meeting.name }}?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="duplicateDialog = false">Nej</v-btn>
          <v-btn text color="primary" type="submit" @click="duplicate"
            >Ja</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="480">
      <v-card>
        <v-card-title
          >Är du säker på att du vill radera {{ meeting.name }}?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Nej</v-btn>
          <v-btn text color="primary" type="submit" @click="remove">Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-title class="color-a" style="background:#fff;margin-bottom: -3px;">
      Redigerar mötet "{{ meeting.name }}"
    </v-card-title>
    <v-card>
      <v-card-text>
        <meeting-form
          ref="form"
          :meeting="meeting"
          :organization="organization"
        ></meeting-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="deleteDialog = true"
          ><v-icon left>mdi-delete</v-icon> Radera möte</v-btn
        >
        <v-btn text @click="duplicateDialog = true"
          ><v-icon left>mdi-content-copy</v-icon> Duplicera möte</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="save">Spara</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MeetingForm from "@/components/meetings/MeetingForm.vue";

export default {
  props: {
    meeting: Object,
    organization: Object
  },
  components: { MeetingForm },
  data() {
    return {
      dialog: false,
      deleteDialog: false,
      duplicateDialog: false
    };
  },
  mounted() {
    this.$root.$on("missingPaymentMetod", () => {
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.$refs.form.close();
      this.dialog = false;
    },
    async save() {
      let payload = {
        meetingId: this.meeting.id,
        ...this.$refs.form.form
      };
      const success = await this.$store.dispatch(
        "meetings/editMeeting",
        payload
      );
      if (success) {
        this.close();
      }
    },
    async remove() {
      const success = await this.$store.dispatch("meetings/deleteMeeting", {
        meetingId: this.meeting.id
      });
      if (success) {
        await this.$router.push({
          name: "organization",
          params: { orgId: this.meeting.organizationId }
        });
      }
    },
    duplicate: async function() {
      const newMeetingId = await this.$store.dispatch(
        "meetings/duplicateMeeting",
        {
          meetingId: this.meeting.id
        }
      );
      if (newMeetingId) {
        await this.$router.push({
          name: "organization",
          params: { orgId: this.meeting.organizationId }
        });
      }
    }
  }
};
</script>

<style></style>
